import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import { PublicProfilesContextService } from '../services/public-profiles-context.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const publicProfiles = inject(PublicProfilesContextService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 || error.status === 499) {
        if (req.url.startsWith(environment.authUrl)) {
          return throwError(() => error);
        }
        if (publicProfiles.isPublicProfilesUrl(router.url)) {
          auth.logout();
          publicProfiles.requestAuth();
        } else if (
          router.url.startsWith('/entretien/repondre') ||
          router.url.startsWith('/matching/repondre') ||
          router.url.startsWith('/offres-partagees') ||
          router.url.startsWith('/offres-publiques')
        ) {
          return throwError(() => error);
        } else {
          auth.logout();
          router.navigate(['/connexion']);
        }
      }
      return throwError(() => error);
    }),
  );
};
